import { gql } from "@apollo/client";

export default gql`
  query getArtifactExplorerTeamsQuery($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      teams {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;
